import Image from 'next/image';
import React, { FC } from 'react';

import IconMark from './assets/icon-mark.svg';

import styles from './part-feature-item.module.scss';

// TODO: update this interface

interface IFeatures {
  [key: string]: any;
}

const PartFeatureItem: FC<IFeatures> = ({ contentItem }) => (
  <>
    <div className={styles.featureItemIconWrap}>
      <Image
        src={contentItem.icon.fields.file?.url ?? ''}
        alt={contentItem.icon.fields.description ?? ''}
        width={contentItem.icon.fields.file?.details.image?.width ?? 0}
        height={contentItem.icon.fields.file?.details.image?.height ?? 0}
      />
    </div>
    <div className={styles.featureItemContainer}>
      <h3 className={styles.featureItemTitle}>{contentItem.title}</h3>
      <div className={styles.featureContentWrap}>
        {contentItem.description && (
        <p className={styles.featureText}>{contentItem.description}</p>
        )}
        {contentItem.list && (
        <ul className={styles.featureContentList}>
          {contentItem.list.map((item: string) => (
            <li key={item} className={styles.featureContentItem}>
              <IconMark />
              <span className={styles.featureText}>{item}</span>
            </li>
          ))}
        </ul>
        )}
      </div>
    </div>
  </>
);

export default PartFeatureItem;
